module.exports = "/assets/800250ac90b844e1d98751961f90e2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FZ.png
// module id = 1387
// module chunks = 0